import { updateTheme } from "../../common/utils/style-utils";
import { setShowTranslationKeys } from "../../common/global";
import { getCurrentUser, getUserProfile } from "../../redux/current-user-slice";
import { updateSettings, updateSystemConfiguration } from "../../redux/settings-slice";
import { store } from "../../redux/store";
import { UserCache } from "../caches";
import { EnvironmentVarService } from "../env-var.service";
import { ClientSystemSettingsService } from "../modules/security/system-settings.service";


import { FabrixSocketsService } from "../socket/fbx-socket.service";
import { ClientSettingsService } from "../modules/core/client-settings.service";
import { updateMetaElement, updateOgMetaElement } from "../../common/utils/basic-utils";
import { JwtAuthService } from "./jwt-auth.service";
import { AppUser } from "@nt-portal/server-sdk";
import { FbxLog } from "../../common/utils/logging.utils";
import { moduleRoutes } from "../../../modules";
import { setModules } from "../../redux/module-slice";
import { setIcons } from "../../redux/icons-slice";
import { fabrixIcons } from "../../common";
import { ModuleInfo } from "../../types";

const appModuleRoutes = moduleRoutes();

export class LoadingService {

    public async loadSettings(env: string) {
        let envServer = new EnvironmentVarService();
        let data = await envServer.load(env);

        store.dispatch(updateSettings(data));


        return data;
    }

    public loadModules() {
        FbxLog.log("1: Loading modules");
        let modules = appModuleRoutes;
        // Note: There is no user loaded at this point so we cannot do this here.
        //  modules = await applyEmployeeCentreCredentialGuard(appModuleRoutes);
        if (modules.length > 0) {
            store.dispatch(setModules(modules));

        }
        this.loadModuleIcons(modules);
        FbxLog.log("2: Modules loaded", modules);
    }

    private loadModuleIcons(modules: ModuleInfo[]) {
        if (modules) {
            let icons = modules.map((x) => x.icons);
            store.dispatch(setIcons(fabrixIcons));
            icons.forEach((i) => {
                if (i) 
                    store.dispatch(setIcons(i));
            });
        }
    }

    public async load() {

        FabrixSocketsService.instance.init("auth", ["notifications"]);

    }

    public async loadCurrentUser() {

        let user: AppUser | undefined;


        if (JwtAuthService.isAuthenticated()) {

            let userLoad = await store.dispatch(getCurrentUser())
            let payload = userLoad.payload as any;

            if (payload?.user?.id) {
                await store.dispatch(getUserProfile())

                let service = new ClientSystemSettingsService();
                let items = await service.getClientSettings()
                store.dispatch(updateSystemConfiguration(items));
                updateTheme();

            }
            user = (userLoad.payload as any).user;

        }

        return user;
    }



    /** This requires authentication */
    public async metaData() {
        let service = new ClientSettingsService();
        return await service.metaData();

    }

    public async setMetaData() {
        const metaData = await this.metaData()

        updateOgMetaElement("title", metaData.title);
        updateOgMetaElement("description", metaData.description);
        updateOgMetaElement("image", metaData.image ?? `${window.location.origin}/01nat-logo.png`);
        updateOgMetaElement("url", window.location.origin);

        updateMetaElement("description", metaData.description);
        // updateMetaElement("og:image", settings.metaDataImage ?? `${window.location.origin}/01nat-logo.png`);

    }

}
